// Copia local de lo aún no guardado: si Android cierra el navegador en segundo plano, se recupera al volver.
// Vive en la pestaña (sessionStorage). Sin espacio solo no hay copia: nunca interrumpe el trabajo.
const clave = (id) => `quetaco:borrador:${id}`;

export const leerBorradorLocal = (id) => { try { return JSON.parse(sessionStorage.getItem(clave(id))); } catch { return null; } };
export const guardarBorradorLocal = (id, datos) => { try { sessionStorage.setItem(clave(id), JSON.stringify(datos)); } catch { /* sin espacio */ } };
export const quitarBorradorLocal = (id) => { try { sessionStorage.removeItem(clave(id)); } catch { /* sin acceso */ } };
